"use strict";
/**
 * Unless explicitly stated otherwise all files in this repository are licensed under the Apache-2.0 License.
 * This product includes software developed at Datadog (https://www.datadoghq.com/).
 * Copyright 2020-Present Datadog, Inc.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntheticsPrivateLocationCreationResponseResultEncryption = void 0;
/**
 * Public key for the result encryption.
 */
class SyntheticsPrivateLocationCreationResponseResultEncryption {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return SyntheticsPrivateLocationCreationResponseResultEncryption.attributeTypeMap;
    }
}
exports.SyntheticsPrivateLocationCreationResponseResultEncryption = SyntheticsPrivateLocationCreationResponseResultEncryption;
/**
 * @ignore
 */
SyntheticsPrivateLocationCreationResponseResultEncryption.attributeTypeMap = {
    id: {
        baseName: "id",
        type: "string",
    },
    key: {
        baseName: "key",
        type: "string",
    },
};
//# sourceMappingURL=SyntheticsPrivateLocationCreationResponseResultEncryption.js.map